export type StripeEndpointResponse = {
    url: string;
    isConfigured: boolean;
    isChargesEnabled: boolean;
    areRequirementsDue: boolean;
};

export type Currency = 'USD' | 'GBP' | 'NZD' | 'AUD' | 'CAD' | 'EUR' | 'CZK' | 'DKK' | 'CHF' | 'ZAR' | 'THB' | 'HKD' | 'SEK' | 'PHP';

export enum PaymentProcessor {
    Square,
    Stripe,
}

export type PaymentIntegrationProps = {
    className?: string;
    onIntegrationEnabled: (processor: PaymentProcessor) => void;
    disabled: boolean;
};
